import React, { useState, useEffect, useRef } from "react";
import ReupServices from "../based/services/ReupServices";
import styled from "styled-components";
import CommonTable from "../based/CommonTable";
import { NOTIFY } from "../based/Constants";
import { Notify } from "../based/Notify";
import { ConfirmDialog } from "../based/Dialog";
import Loading from "../based/Loading";
import TFUSelect from "../based/inputs/TFUSelect";
import Request from "../based/Request";

const initPage = {
    pageSize: 10,
    pageNumber: 1,
};

const modelAppAccount = {
    id: 0,
    appId: 0,
    accountName: "",
    profileLink: "",
    avatar: "",
    note: "",
    mainAccountId: 0,
    x: 0,
    y: 0,
    isDelete: false,
};

const AppAccountNewFileManagement = () => {
    const [data, setData] = useState([]);
    const [paging, setPaging] = useState(initPage);
    const [isBusy, setBusy] = useState(true);
    const [msg, setMsg] = useState("");
    const tableRef = useRef(null);
    const [dataMainAcc, setDataMainAcc] = useState([]);

    useEffect(() => {
        setBusy(false);
        getData(paging);
    }, []);

    async function getData(newPaging) {
        setBusy(true);
        setMsg("Đang tải dữ liệu...");
        let [err, data] = await ReupServices.GetAppAccountByPage(newPaging);
        if (!err && data) {
            setData(data.listObjects);
            setPaging(data.paging);
            setBusy(false);
        } else {
            setData([]);
            setBusy(false);
        }
    }

    useEffect(() => {
        getMainAccountDropDown();
    }, []);

    async function getMainAccountDropDown() {
        setBusy(true);
        setMsg("Đang tải dữ liệu...");
        let [err, data] = await ReupServices.GetMainAccountDropDown();
        if (!err && data) {
            setDataMainAcc(data);
            setBusy(false);
        } else {
            setDataMainAcc([]);
            setBusy(false);
        }
    }

    function _renderHeader() {
        return (
            <thead>
                <tr className="text-center">
                    <th>STT</th>
                    <th>Tài khoản chính</th>
                    <th>Tên Tài khoản/Trang/Kênh</th>
                    <th>Link</th>
                    <th>Hình mô tả</th>
                    <th>Note</th>
                    <th>Hành động</th>
                </tr>
            </thead>
        );
    }

    async function handleUploadFile(e, index, data) {
        let reader = new FileReader();
        let file = e.target.files[0];
        if (file) {
            reader.onloadend = () => {
                Request.UploadImage(file)
                    .then((res) => {
                        if (res && res.data) {
                            let dt = [...data];
                            dt[index].avatar = res.data.imageUrl;
                            setData(dt);
                        } else {
                            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Upload failed");
                        }
                    })
                    .catch((err) => {
                        Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Upload failed");
                    });
            };

            reader.readAsDataURL(file);
        }
    }

    function _renderBody() {
        return (
            <tbody>
                {" "}
                {data && data.length > 0 ? (
                    data.map((item, idx) => {
                        return (
                            <tr className={idx}>
                                <td style={{ width: 50, textAlign: "center" }}>{idx + 1}</td>
                                <td style={{ width: 250 }}>
                                    {item.id <= 0 || item.isUpdate ? (
                                        <TFUSelect
                                            className="select"
                                            options={dataMainAcc}
                                            placeholder="--Chọn tài khoản chính--"
                                            value={item.mainAccountId}
                                            onChanged={(value) => {
                                                let dt = [...data];
                                                dt[idx].mainAccountId = value;
                                                setData(dt);
                                            }}
                                        />
                                    ) : (
                                        item.nameMainAccount
                                    )}
                                </td>
                                <td style={{ width: 250 }}>
                                    {item.id <= 0 || item.isUpdate ? (
                                        <input
                                            className="input-in-table"
                                            type="text"
                                            placeholder="Tên trang/ kênh"
                                            value={item.accountName}
                                            onChange={(e) => {
                                                let dt = [...data];
                                                dt[idx].accountName = e.target.value;
                                                setData(dt);
                                            }}
                                        />
                                    ) : (
                                        item.accountName
                                    )}
                                </td>
                                <td style={{ width: 250 }}>
                                    {item.id <= 0 || item.isUpdate ? (
                                        <input
                                            className="input-in-table"
                                            type="text"
                                            placeholder="Link"
                                            value={item.profileLink}
                                            onChange={(e) => {
                                                let dt = [...data];
                                                dt[idx].profileLink = e.target.value;
                                                setData(dt);
                                            }}
                                        />
                                    ) : (
                                        item.profileLink
                                    )}
                                </td>
                                <td style={{ width: 250, textAlign: "center", position: 'relative' }}>
                                    {item.id <= 0 || item.isUpdate ? (
                                        <div>
                                            {item.avatar ? (
                                                <label for={`upload-${idx}`} style={{ display: "block", width: "100%", height: "100%" }}>
                                                    <img style={{ maxWidth: 250, maxHeight: 100 }} src={item.avatar} />
                                                    <span style={{ position: 'absolute', top: 10 , right: 10 , fontSize: 30 , lineHeight: 0.5}} onClick={()=>{
                                                            let dt = [...data]
                                                            dt[idx].avatar = ""
                                                            setData(dt)
                                                        }}>
                                                            &times;
                                                        </span>

                                                </label>
                                            ) : (
                                                ""
                                            )}
                                            <input
                                                style={{maxWidth: 90}} 
                                                accept="image/*"
                                                hidden={item.avatar ? true : false}
                                                type="file"
                                                id={`upload-${idx}`}
                                                onChange={(e) => {
                                                    handleUploadFile(e, idx, data);
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <img style={{ maxWidth: 250, maxHeight: 100 }} src={item.avatar} />
                                    )}
                                </td>
                                <td style={{ width: 250 }}>
                                    {item.id <= 0 || item.isUpdate ? (
                                        <input
                                            className="input-in-table"
                                            type="text"
                                            placeholder="Ghi chú"
                                            value={item.note}
                                            onChange={(e) => {
                                                let dt = [...data];
                                                dt[idx].note = e.target.value;
                                                setData(dt);
                                            }}
                                        />
                                    ) : (
                                        item.note
                                    )}
                                </td>
                                <td style={{ width: 150, textAlign: "center" }}>
                                    {item.isUpdate || item.id <= 0 ? (
                                        <button
                                            className={`btn btn-custom m-1  ${IsDisable(idx) ? "disabled" : ""}`}
                                            onClick={() => {
                                                if (!IsDisable(idx)) handleCreateOrUpdate(idx);
                                            }}
                                        >
                                            Xong
                                        </button>
                                    ) : (
                                        <button
                                            className="btn btn-custom m-1"
                                            onClick={() => {
                                                let dt = [...data];
                                                dt[idx].isUpdate = true;
                                                setData(dt);
                                            }}
                                        >
                                            Sửa
                                        </button>
                                    )}
                                    <button
                                        className={"btn btn-danger m-1"}
                                        onClick={() => {
                                            handleDelete(item.id, idx);
                                        }}
                                    >
                                        Xóa
                                    </button>
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan={99}>Không có dữ liệu</td>
                    </tr>
                )}
                <tr>
                    <td colSpan={99}>
                        <div
                            className="add-item"
                            style={{
                                color: "#64C5B1",
                                fontSize: "16px",
                                fontWeight: 600,
                                cursor: "pointer",
                                marginBottom: "10px",
                            }}
                            onClick={() => {
                                handleAddItem();
                            }}
                        >
                            Thêm +
                        </div>
                    </td>
                </tr>
            </tbody>
        );
    }

    function _renderAction() {}

    async function handleAddItem() {
        setData([{ ...modelAppAccount }, ...data]);
    }

    function IsDisable(idx) {
        if (data[idx].mainAccountId <= 0 || !data[idx].profileLink || !data[idx].accountName) return true;
        return false;
    }
    async function handleCreateOrUpdate(idx) {
        setBusy(true);
        let dataItem = { ...data[idx] };
        let [err, dt] = await ReupServices.CreateUpdateAppAccount(dataItem);
        if (!err && dt) {
            getData(initPage);
            setBusy(false);
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Lưu thành công");
        } else {
            setBusy(false);
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Lưu thất bại");
        }
    }

    async function handleDelete(id, idx) {
        if (id > 0) {
            let ids = [];
            ids.push(id);
            ConfirmDialog("Xác nhận xóa?", "Xin vui lòng xác nhận để xóa ", () => {
                return new Promise(async (resolve, reject) => {
                    let [error, data] = await ReupServices.DeleteAppAccount(ids);
                    if (!error && data) {
                        resolve({ title: "Thành công", msg: "Xóa thành công." });
                        getData(paging);
                    } else {
                        Notify(NOTIFY.WARNING, "Có lỗi", "Có lỗi xảy ra trong quá trình xóa.");
                    }
                });
            });
        } else {
            let newData = [...data];
            newData.splice(idx, 1);
            setData(newData);
        }
    }

    return (
        <StyleBody>
            <Loading show={isBusy} msg={msg} />
            <CommonTable data={data} paging={paging} hideSearchBasicButton renderAction={_renderAction} renderHeader={_renderHeader} renderBody={_renderBody} ref={tableRef} onFilter={(paging) => getData(paging)} />
        </StyleBody>
    );
};
const StyleBody = styled.div`
    .input-in-table {
        border: none;
        outline: none;
        width: 100%;
        height: 40px;
        padding: 0;
        display: block;

        ::placeholder {
            opacity: 0.3;
        }
    }
`;
export default AppAccountNewFileManagement;
